export default "__VITE_ASSET__CwCMEj2c__"